// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- CompanyAvatar is a local styled wrapper around the MUI avatar primitive.
import { Avatar, Box, Collapse, Typography } from '@mui/material';
import styled from 'styled-components';

import { Button } from '@/shared/components/ui/button/button';

export const SwitchCompanyButton = styled(Button)`
  && {
    border-radius: ${({ theme }) => theme.shape.buttonRadius.large};
    overflow: hidden;
    background-color: ${({ theme }) => theme.palette.primary.light};
    justify-content: flex-start;
    text-align: initial;
    padding: 0;
    height: 2.75rem;
    width: 100%;
    min-width: 2.75rem;

    &:hover {
      background-color: ${({ theme }) => theme.palette.stroke.secondary};
    }

    &:disabled {
      opacity: 1;
      background-color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`;

export const ButtonContentWrapper = styled(Box)`
  && {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.25rem;
  }
`;

export const CustomCollapse = styled(Collapse)`
  && {
    width: ${(props) => (props.in ? '100% !important' : 0)};

    .MuiCollapse-wrapperInner {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.25rem;

      svg {
        color: ${({ theme }) => theme.palette.text.secondary};
      }
    }
  }
`;

export const CompanyName = styled(Typography)`
  && {
    max-height: ${({ theme }) => theme.spacing(9)};
    flex: 1;
    overflow: hidden;
    color: ${({ theme }) => theme.palette.text.primary};
    white-space: normal;
    ${({ theme }) => theme.typography.button2};
  }
`;

export const CompanyAvatar = styled(Avatar)`
  && {
    border-radius: ${({ theme }) => theme.shape.buttonRadius.medium};
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.primary};
    width: 2.25rem;
    height: 2.25rem;
    ${({ theme }) => theme.typography.p7};
  }
`;
